module.exports = __webpack_public_path__ + "images/store_case_study/otachu-pic2_5ab66e918d60bea0a16500538fff9973.png";